module.exports = new __parcel__URL__("empty.368985dc.svg").toString();